import type { FoodActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: FoodActivity;
}

export const FoodActivityTitle = forwardRef<HTMLDivElement, Props>(
  function FoodActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      ...htmlDivProps
    } = props

    if (!activity.title) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {props.activity.title}
      </div>
    )
  },
)
